import { Box, Stack } from "@mui/material";
import AudioTone from "./patterns/AudioTone";
import ColorBars from "./patterns/ColorBars";
import ColorBarsPD from "./patterns/ColorBarsPD";
import Grid from "./patterns/Grid";
import Safety from "./patterns/Safety";
import CustomLetterbox from "./patterns/CustomLetterbox";
import MovingGradient from "./patterns/MovingGradient";
import Snake from "./patterns/Snake";

const generatePattern = (pattern, gridSize, circles, luma, text, grid, bkgndColor, letterboxWidth, letterboxHeight, letterboxAlignVertical, letterboxAlignHorizontal, letterboxOutputResolution, audioFrequency, audioVolume, onAudioFrequencyChange, onAudioVolumeChange, gradientColor1, gradientColor2, width, height) => {
   switch (pattern) {
      case "colorBars":
         return <ColorBars />;
      case "colorBarsPD":
         return <ColorBarsPD width={width} height={height} />;
      case "grid":
         return <Grid text={text} circles={circles} luma={luma} grid={grid} gridSize={gridSize} width={width} height={height} />;
      case "safety":
         return <Safety width={width} height={height} />;
      case "customLetterbox":
         return (
            <CustomLetterbox
               letterboxWidth={letterboxWidth}
               letterboxHeight={letterboxHeight}
               letterboxAlignVertical={letterboxAlignVertical}
               letterboxAlignHorizontal={letterboxAlignHorizontal}
               letterboxOutputResolution={letterboxOutputResolution}
            />
         );
      case "audioTone":
         return (
            <AudioTone
               frequency={audioFrequency}
               volume={audioVolume}
               onFrequencyChange={onAudioFrequencyChange}
               onVolumeChange={onAudioVolumeChange}
            />
         );
      case "movingGradient":
         return (
            <MovingGradient
               gradientColor1={gradientColor1}
               gradientColor2={gradientColor2}
            />
         );
      case "snake":
         return <Snake />;
      default:
         return (
            <Stack
               sx={{ width: "100%", height: "100%" }}
               alignItems='center'
               justifyContent='center'
            >
               <Box sx={{ fontSize: 100, color: "#efefef" }}>
                  Select a Pattern
               </Box>
            </Stack>
         );
   }
};

export default function Patterns({ pattern, gridSize, circles, luma, text, grid, bkgndColor, letterboxWidth, letterboxHeight, letterboxAlignVertical, letterboxAlignHorizontal, letterboxOutputResolution, audioFrequency, audioVolume, onAudioFrequencyChange, onAudioVolumeChange, gradientColor1, gradientColor2, resolution, width, height }) {
   // Determine canvas dimensions based on pattern and resolution
   let canvasWidth = width || 1920;
   let canvasHeight = height || 1080;
   
   if (pattern === "customLetterbox" && letterboxOutputResolution) {
      const [w, h] = letterboxOutputResolution.split('x').map(Number);
      canvasWidth = width || w;
      canvasHeight = height || h;
   } else if (resolution && !width && !height) {
      const [w, h] = resolution.split('x').map(Number);
      canvasWidth = w;
      canvasHeight = h;
   }
   
   return (
      <Box
         sx={{
            width: width ? `${width}px` : "100%",
            height: height ? `${height}px` : "100%",
            border: "1px solid #000",
            backgroundColor: pattern === "audioTone" || pattern === "safety" ? "transparent" : bkgndColor,
            overflow: "hidden",
            position: "relative",
         }}
      >
         {generatePattern(pattern, gridSize, circles, luma, text, grid, bkgndColor, letterboxWidth, letterboxHeight, letterboxAlignVertical, letterboxAlignHorizontal, letterboxOutputResolution, audioFrequency, audioVolume, onAudioFrequencyChange, onAudioVolumeChange, gradientColor1, gradientColor2, width, height)}   
      </Box>
   );
}
